import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import GttLogo from '../../../../common/icons/GttLogo';
import GttName from '../../../../common/icons/GttName';
import UserMenu from '../UserMenu';
import {
  ADMIN_LANDING_PAGE,
  AGENCY_LANDING_PAGE,
} from '../../../../common/constants';
import './style.css';
import { UserRole, UserType } from '../../../../common/enums';
import useAgency from '../../../configuration/hooks/useAgency';
import useUser from '../../../userAuth/hooks/useUser';

const { Header } = Layout;

// Check if string is all uppercase
const isUpperCase = (str) => str === str.toUpperCase();

// Format string to either all caps or title case
const formatString = (name) => {
  if (isUpperCase(name) === true) {
    return name;
  }
  const result = name
    .replace(/([_])/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
  return result;
};

const NavHeader = () => {
  const [homeLink, setHomeLink] = useState('');

  const { accessToken, userType, userHasRole } = useUser();
  const { agency } = useAgency();

  useEffect(() => {
    if (
      accessToken &&
      userHasRole([UserRole.ORG_ADMIN, UserRole.READ_WRITE]) === true
    ) {
      setHomeLink(ADMIN_LANDING_PAGE);
      return;
    }
    if (accessToken && userType === UserType.AgencyViewer) {
      setHomeLink(AGENCY_LANDING_PAGE);
    }
    if (accessToken && userType === UserType.AgencyAdmin) {
      setHomeLink(`/config/agency-settings`);
    }
  }, [accessToken, userType, userHasRole]);

  return (
    <Header>
      <Link to={homeLink}>
        <GttLogo />
        <GttName />
      </Link>
      <UserMenu title={agency?.name} />
    </Header>
  );
};

export default NavHeader;
